module.exports = __webpack_public_path__ + "img/kefu4.376a8cc4.png";